// extracted by mini-css-extract-plugin
module.exports = {"container":"PolicyLabeledContent_container__VjEIq","label":"PolicyLabeledContent_label__SHfkU","text":"PolicyLabeledContent_text__yLUDD"};